import { SAMPLE_AGS_DEMOS } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { AppState } from '~/store/app.store';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';

const result = SAMPLE_AGS_DEMOS.reduce((acc, { boundaryGroupId }, index) => {
  acc[boundaryGroupId] = -index - 1;
  return acc;
}, {} as Record<BoundaryGroupId, BoundaryTerritoryGroupId>);

export const activeBTGIdPerDataLayerBoundaryGroupSelector = (_state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return result;
};
